import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Modal from '../../containers/modal';
import { useViewport } from '../../hooks/useViewport';
import Card from './MealReservationCard';
import CountdownTimer from './CountDownTimer';
import './index.scss';
import { PrebookModalHeader } from './AvengersDoomsday';
import MealButton from './MealButton';
import Icon from './Icon';
import { extraPreBookMealInfo } from '../../utils/services';
import Loader from '../loader-spin';
import { getPrebookInfo } from '../../burger-king-lib/redux/home/actions';

const PreMealOrderStatusModal = ({ onClose }) => {
  const { isMobile } = useViewport();
  const { preBookInfo, isPrebookModalOpened } = useSelector(
    state => state.home
  );
  const dispatch = useDispatch();

  const handleClose = () => {
    if (typeof onClose === 'function') onClose();
  };

  const preBook = extraPreBookMealInfo(preBookInfo);

  useEffect(() => {
    if (!isPrebookModalOpened) return;

    if (!preBookInfo) {
      dispatch(getPrebookInfo());
    }
  }, []);

  return (
    <Modal
      isMobileFullLayout={isMobile}
      hideClose
      modalCustomClass="pre-meal-status-model"
      contentCustomClass="pre-meal-status-model__modal-wrapper"
      onCloseHandler={handleClose}
      width="375px"
    >
      <PrebookModalHeader title="Your Prebook" onGoBack={handleClose} />
      {!preBook ? (
        <Loader />
      ) : (
        <div className="pre-meal-status-model__outer-wrapper">
          <Card className="meal-card">
            <Card.Image />
            <div className="inner-wrapper">
              <div>
                <Card.Chip>{preBook.status}</Card.Chip>
                <Card.Heading>
                  Your meal is {(preBook?.status || '').toLowerCase()}
                </Card.Heading>
                <Card.Description>{preBook?.productName}</Card.Description>
              </div>
              <CountdownTimer endDate={preBook.unLocksAt} />
            </div>
          </Card>
          <section className="checkout-total" aria-label="Payment summary">
            <div className="checkout-total__payable">
              <span>Pre-book ID</span>
              <span>{preBook?.preBookID}</span>
            </div>
            <div className="checkout-total__payable">
              <span>Account</span>
              <span>{preBook?.mobileNumber}</span>
            </div>
            <div className="checkout-total__payable">
              <span>Amount paid</span>
              <span>₹ {preBook.amount}</span>
            </div>
            <div className="checkout-total__payable">
              <span>Unlocks</span>
              <span>{preBook.unLocksAt}</span>
            </div>
            <div className="checkout-total__payable">
              <span>Valid until</span>
              <span>{preBook.redeemUntil}</span>
            </div>
            <div className="checkout-total__payable">
              <span>Fulfilment</span>
              <span>Dine-in only</span>
            </div>
          </section>
          <MealButton
            size="sm"
            className="navigation"
            endIcon={<Icon name="leftArrow" className="icon" />}
          >
            Pre-book terms and refund policy
          </MealButton>
        </div>
      )}
    </Modal>
  );
};

export default PreMealOrderStatusModal;
